import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=6f5139a5&scoped=true"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthDialog.vue?vue&type=style&index=0&id=6f5139a5&prod&lang=scss"
import style1 from "./AuthDialog.vue?vue&type=style&index=1&id=6f5139a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5139a5",
  null
  
)

export default component.exports